<template>
  <div class="email">
    <navbar />
    <banner />
    <mainContainer />
    <footerBox />
  </div>
</template>

<script>
import navbar from './component/navbar.vue'
import banner from './component/banner.vue'
import mainContainer from './component/mainContainer.vue'
import footerBox from './component/footer.vue'
export default {
  name: 'email',
  components: {
    navbar,
    banner,
    mainContainer,
    footerBox
  },
  created () {
    this.$i18n.locale = localStorage.getItem("lang")
  }
}
</script>

<style lang="scss" scoped>
.email {
  background: #fff;
}
</style>
